import { Component, input } from '@angular/core';

@Component({
    selector: 'gea-svg-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent {
    size = input<number>(16)
}
